import {
    ChangeDetectionStrategy,
    Component,
    input,
    model
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Section card chrome used across the product-details panel: white surface,
 * hairline border, large radius, and a header row with a title, optional count
 * pill, and an optional right-aligned caption. Body content is projected; pass
 * [padded]="false" for full-bleed contents such as data tables. Header-side
 * actions can be projected into the [ancCardHeaderActions] slot.
 */
@Component({
    selector: 'lib-anc-panel-card',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-panel-card.component.html',
    styleUrls: ['./anc-panel-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[attr.title]': 'null'
    }
})
export class AncPanelCardComponent {
    /** Card heading (run through translate). */
    title = input<string>('');
    /** Count pill shown next to the title; hidden when null. */
    count = input<number | null>(null);
    /** Right-aligned hint text in the header (run through translate). */
    caption = input<string>('');
    /** Apply standard body padding; set false for full-bleed tables. */
    padded = input<boolean>(true);
    /** Toggle the collapsible feature. */
    collapsible = input<boolean>(true);
    /** Two-way collapsed state. */
    collapsed = model<boolean>(false);

    /** Toggles the expansion/collapse state. */
    toggle(event: MouseEvent | KeyboardEvent): void {
        if (!this.collapsible()) {
            return;
        }

        const target = event.target as HTMLElement;
        const headerElement = event.currentTarget as HTMLElement;
        const interactiveElement = target.closest(
            'button, a, input, select, textarea, [role="button"]'
        );
        const isInteractive =
            interactiveElement !== null && interactiveElement !== headerElement;
        const isHeaderActions =
            target.closest('[ancCardHeaderActions]') !== null;

        if (isInteractive || isHeaderActions) {
            return;
        }

        this.collapsed.update((v) => !v);
    }
}
